import { useEffect, useState } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Alert,
  LinearProgress,
} from '@mui/material';
import { apiFetch } from '../api';

export default function LogDetailPage() {
  const { id } = useParams();
  const [log, setLog] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLog = async () => {
      try {
        const response = await apiFetch(`/api/logs/${id}/`);
        if (!response.ok) {
          throw new Error('Failed to fetch log');
        }
        const data = await response.json();
        setLog(data);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchLog();
  }, [id]);

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  if (!log) {
    return (
      <Container sx={{ py: 4 }}>
        <LinearProgress />
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Log Details
      </Typography>
      <Typography variant="body1" gutterBottom>
        File: {log.visible_name || log.file.split('/').pop()}
      </Typography>
      <Typography variant="body1" gutterBottom>
        Status: {log.status}
      </Typography>
      {log.status === 'complete' && (
        <>
          <Button
            variant="contained"
            component={RouterLink}
            to={`/logs/${id}/las-files`}
            sx={{ mt: 2, mr: 2 }}
          >
            Download LAS
          </Button>
          <Button
            variant="outlined"
            component={RouterLink}
            to={`/logs/${id}/las-files`}
            sx={{ mt: 2, mr: 2 }}
          >
            View LAS
          </Button>
          <Button
            variant="outlined"
            component={RouterLink}
            to={`/logs/${id}/qc`}
            sx={{ mt: 2 }}
          >
            QC View
          </Button>
        </>
      )}
    </Container>
  );
}
